import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";


declare var ko: any;

interface Option {id: number; name: string;}
interface State {id: string; name: string;}
interface Group {name: string; states: Array<State>;}
interface Country extends Option{
    groups: Array<Group>;
}
export class countryStates_template extends vnTemplate {

    protected getTemplateHtml(): string {

        return /*html*/ `

            <label class="form-label" data-bind="attr: {for: idElement}, text: label"></label><br/>
            <!-- ko if: selectedCountry() -->
            <select data-bind="id: idElement, value: selectedState">
                <option data-bind="value: ''">Select</option>
                <!-- ko foreach: selectedCountry().groups -->
                    <!-- ko if : $data.states -->
                    <optgroup data-bind="attr:{label: name}" label="">
                     <!-- ko foreach : $data.states -->
                        <option data-bind="value: id, text: name"></option>
                     <!-- /ko -->
                    </optgroup>
                    <!-- /ko -->
                <!-- /ko -->
            </select>
            <!-- /ko -->
            <!-- ko ifnot: selectedCountry() -->
            <input id="selectedState" data-bind="value: selectedState" type="text" class="input-text">
            <!-- /ko -->
            `;
    }

    protected initPartial(): void {}

    protected getTemplateName(): string {

        return "countryStates_template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["form-group"];
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            idElement: ko.observable("selectedState_" + self.idElement),
            label: ko.observable("State/Province/Region"),
            idCountry: ko.observable(null),
            selectedState: ko.observable(null),
            selectedCountry: ko.observable(null)
        };
    }

    public setCountryId(idCountry): void {
        this.getTemplateViewModel().idCountry(idCountry);
    }
    public getCountryId() {
        return this.getTemplateViewModel().idCountry();
    }
    public setCountryAndState(idCountry, state): void {
        this.setCountryId(idCountry);
        let country: Country = this.getCountryById(idCountry);
        if (country) {
            this.setSelectedCountry(country);
            if (state) {
                this.setState(country, state);
            } else {
                this.setSelectedState(null);
            }
        } else {
            this.setSelectedCountry(null);
            if (state) {
                this.setSelectedState(state);
            } else {
                this.setSelectedState(null);
            }
        }
    }

    public reset(): void {
        this.setSelectedCountry(null);
        this.setSelectedState(null);
        this.setCountryId(null);
    }

    public setState(country: Country, state: string): void {

        let foundState = null;
        country.groups.forEach((g) => {
            g.states.forEach((s) => {
                if (String(s.id).toLowerCase().trim() == String(state).toLowerCase().trim()) {
                    foundState = s.id;
                    return;
                }
            });
            if (foundState) return;
        });

        if (foundState) {
            this.setSelectedState(foundState);
        }
    }
    public setSelectedState(selectedState) {

        this.getTemplateViewModel().selectedState(selectedState);
    }
    public getSelectedState() {
        return this.getTemplateViewModel().selectedState();
    }

    public setSelectedCountry(country?: Country): void {
        this.getTemplateViewModel().selectedCountry(country);
    }

    public getSelectedCountry(): Country|null {
        return this.getTemplateViewModel().selectedCountry();
    }

    public getCountryById(countryId): Country|null {
        let countries =  this.getCountriesList().filter((c) => c.id == countryId);
        let self =  this;
        if (countries.length > 0) {
            return countries[0];
        }

        return null;
    }

    public getCountriesList(): Array<Country> {
        return [
            {
                id: 197,
                name: "USA",
                groups: [
                    {
                        name: "United States - States",
                        states: [
                            {id: "Alabama", name: "Alabama"},
                            {id: "Alaska", name: "Alaska"},
                            {id: "Arizona", name: "Arizona"},
                            {id: "Arkansas", name: "Arkansas"},
                            {id: "California", name: "California"},
                            {id: "Colorado", name: "Colorado"},
                            {id: "Connecticut", name: "Connecticut"},
                            {id: "Delaware", name: "Delaware"},
                            {id: "Florida", name: "Florida"},
                            {id: "Georgia", name: "Georgia"},
                            {id: "Hawaii", name: "Hawaii"},
                            {id: "Idaho", name: "Idaho"},
                            {id: "Illinois", name: "Illinois"},
                            {id: "Indiana", name: "Indiana"},
                            {id: "Iowa", name: "Iowa"},
                            {id: "Kansas", name: "Kansas"},
                            {id: "Kentucky", name: "Kentucky"},
                            {id: "Louisiana", name: "Louisiana"},
                            {id: "Maine", name: "Maine"},
                            {id: "Maryland", name: "Maryland"},
                            {id: "Massachusetts", name: "Massachusetts"},
                            {id: "Michigan", name: "Michigan"},
                            {id: "Minnesota", name: "Minnesota"},
                            {id: "Mississippi", name: "Mississippi"},
                            {id: "Missouri", name: "Missouri"},
                            {id: "Montana", name: "Montana"},
                            {id: "Nebraska", name: "Nebraska"},
                            {id: "Nevada", name: "Nevada"},
                            {id: "New Hampshire", name: "New Hampshire"},
                            {id: "New Jersey", name: "New Jersey"},
                            {id: "New Mexico", name: "New Mexico"},
                            {id: "New York", name: "New York"},
                            {id: "North Carolina", name: "North Carolina"},
                            {id: "North Dakota", name: "North Dakota"},
                            {id: "Ohio", name: "Ohio"},
                            {id: "Oklahoma", name: "Oklahoma"},
                            {id: "Oregon", name: "Oregon"},
                            {id: "Pennsylvania", name: "Pennsylvania"},
                            {id: "Rhode Island", name: "Rhode Island"},
                            {id: "South Carolina", name: "South Carolina"},
                            {id: "South Dakota", name: "South Dakota"},
                            {id: "Tennessee", name: "Tennessee"},
                            {id: "Texas", name: "Texas"},
                            {id: "Utah", name: "Utah"},
                            {id: "Vermont", name: "Vermont"},
                            {id: "Virginia", name: "Virginia"},
                            {id: "Washington", name: "Washington"},
                            {id: "West Virginia", name: "West Virginia"},
                            {id: "Wisconsin", name: "Wisconsin"},
                            {id: "Wyoming", name: "Wyoming"},
                        ]
                    },
                    {
                        name: "United States - Territories/Regions",
                        states: [
                            {id: "American Samoa", name: "American Samoa"},
                            {id: "District of Columbia", name: "District of Columbia"},
                            {id: "Guam", name: "Guam"},
                            {id: "Northern Mariana Islands", name: "Northern Mariana Islands"},
                            {id: "Puerto Rico", name: "Puerto Rico"},
                            {id: "U.S. Virgin Islands", name: "U.S. Virgin Islands"},
                        ]
                    }
                ]
            },
            {
                id: 32,
                name: "Canada",
                groups: [
                    {
                        name: "Canada - Provinces",
                        states: [
                            {id: "Alberta", name: "Alberta"},
                            {id: "British Columbia", name: "British Columbia"},
                            {id: "Manitoba", name: "Manitoba"},
                            {id: "New Brunswick", name: "New Brunswick"},
                            {id: "Newfoundland and Labrador", name: "Newfoundland and Labrador"},
                            {id: "Nova Scotia", name: "Nova Scotia"},
                            {id: "Ontario", name: "Ontario"},
                            {id: "Prince Edward Island", name: "Prince Edward Island"},
                            {id: "Quebec", name: "Quebec"},
                            {id: "Saskatchewan", name: "Saskatchewan"},
                        ]
                    },
                    {
                        name: "Canada - Territories/Regions",
                        states: [
                            {id: "Northwest Territories", name: "Northwest Territories"},
                            {id: "Nunavut", name: "Nunavut"},
                            {id: "Yukon", name: "Yukon"},
                        ]
                    }
                ]
            }
        ];
    }

    public setLabel(label): void {
        this.getTemplateViewModel().label(label);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/countryStates_template.ts